import { Routes, Route } from "react-router";
import { withSentryReactRouterV7Routing } from "@sentry/react";
import { StatementSurveyWrapper } from "./components/statement";
import { ChooseTheme } from "./components/choose_theme";
import { createContext } from "react";
import translate from "./locales";
import { apiClient } from "./client";

export const SentryRoutes = withSentryReactRouterV7Routing(Routes);

export const LocaleContext = createContext({});
export const RootContext = createContext(null);

export default function App({ locale, root }) {
  function translateWithLocale(key, interpolations, specifiedLocale = locale) {
    return translate(key, interpolations, specifiedLocale);
  }

  return (
    <RootContext value={root}>
      <LocaleContext value={{ locale, translate: translateWithLocale }}>
        <SentryRoutes>
          <Route path="/" element={<ChooseTheme />} />
          <Route
            path="/:statement"
            element={<StatementSurveyWrapper apiClient={apiClient} />}
          />
        </SentryRoutes>
      </LocaleContext>
    </RootContext>
  );
}
